import React from "react";

function useDirtyForm<T extends string>() {
  const [dirtyMap, setDirtyMap] = React.useState<Partial<Record<T, boolean>>>(() => ({}));

  const dirty = React.useMemo(() => Object.values(dirtyMap).some(value => value), [dirtyMap]);

  // If a columnName is present, we set the map accordingly => multiple inputs in the form
  // If no columnName is present, the form is asking to reset its dirty state (when ths user is changing the edited line)
  const setDirty = React.useCallback((isDirty: boolean, columnName: T | null) => {
    if (columnName) {
      setDirtyMap(oldMap => ({ ...oldMap, [columnName]: isDirty }));
    } else {
      setDirtyMap({});
    }
  }, []);

  return React.useMemo(() => [dirty, setDirty] as const, [dirty, setDirty]);
}

export default useDirtyForm;
